import React, { useEffect } from 'react';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEye } from 'react-icons/fa';
import { BasicContent } from '../components';
import { Loading, Paginate } from '~/components';
import { loadPessoaFisicas } from '~/store/modules/pessoa_fisica/action';
import Show from '../Show';

const List = () => {
  let location = useLocation();
  let modal = location.state && location.state.modal;
  const dispatch = useDispatch();
  const { pessoa_fisicas } = useSelector(
    ({ PessoaFisicaReducer }) => PessoaFisicaReducer
  );

  useEffect(() => {
    dispatch(loadPessoaFisicas());
  }, [dispatch]);


  useEffect(() => {
    // console.log(pessoa_fisicas);
  }, [pessoa_fisicas]);


  const breadcrumb = {
    label: 'Lista',
    to: '/empreendimentos/pessoa_fisica',
    active: false,
  };

  return (
    <>
      {modal && (
        <Switch>
          <Route
            children={<Show />}
            exact
            path="/empreendimentos/pessoa_fisica/:pessoa_fisica_id/detalhe"
          />

        </Switch>
      )}
      <BasicContent breadcrumb={breadcrumb}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Lista</h2>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Email</th>
                    <th className="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pessoa_fisicas.data &&
                    pessoa_fisicas.data.map((pessoa_fisica, index) => (
                      <tr key={index}>
                        <td>{pessoa_fisica.id}</td>
                        <td>{pessoa_fisica.nome}</td>
                        <td>{pessoa_fisica.cpf}</td>
                        <td>{pessoa_fisica.email}</td>
                        <td>
                          <div className="btn-group float-right">
                            <Link
                              className="btn btn-info"
                              to={{
                                pathname: `/empreendimentos/pessoa_fisica/${pessoa_fisica.id}/detalhe`,
                                state: { modal: true },
                              }}
                            >
                              <FaEye /> Detalhes
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!pessoa_fisicas && <Loading />}
            </div>
          </div>
          <div className="card-footer clearfix">
            <Paginate
              load={loadPessoaFisicas}
              meta={pessoa_fisicas.meta}
            />
          </div>
        </div>
      </BasicContent>
    </>
  );
};

export default List;
